import { AbstractCodeValue } from "./abstractCodeValue";

export class StoredCodeValue extends AbstractCodeValue {

}